import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)
var customActions = {
  getItemStatistics: {method: 'GET', url: 'statistics/item{/id}'},
  getTeacherItemStatistics: {method: 'GET', url: 'statistics{?teacher=teacherId}'},
  getEvolution: {method: 'GET', url: 'statistics/evolution{?teacher=teacherId}'}
}

export const StatisticsResource = () => {
  return Vue.resource('statistics', {}, customActions)
}



// WEBPACK FOOTER //
// ./src/api/statistics.js